const EcuadorSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111350)">
      <path
        d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20L20 21.7391L0 20Z"
        fill="#FFDA44"
      />
      <path
        d="M2.67676 29.9997C6.13496 35.9775 12.5978 39.9997 20.0005 39.9997C27.4032 39.9997 33.8661 35.9775 37.3243 29.9997L20.0005 28.6953L2.67676 29.9997Z"
        fill="#D80027"
      />
      <path
        d="M37.3237 30C39.0255 27.0583 40 23.643 40 20H0C0 23.643 0.974531 27.0583 2.67625 30H37.3237Z"
        fill="#0052B4"
      />
      <path
        d="M19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.8419 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0002 24.3473C17.6027 24.3473 15.6523 22.3968 15.6523 19.9995V17.3908C15.6523 14.9934 17.6028 13.043 20.0002 13.043C22.3975 13.043 24.348 14.9934 24.348 17.3908V19.9995C24.348 22.3969 22.3976 24.3473 20.0002 24.3473Z"
        fill="#338AF3"
      />
      <path
        d="M26.9566 9.56629H21.7392C21.7392 8.60582 20.9605 7.82715 20 7.82715C19.0396 7.82715 18.2609 8.60582 18.2609 9.56629H13.0435C13.0435 10.5268 13.8801 11.3054 14.8405 11.3054H14.7826C14.7826 12.266 15.5612 13.0446 16.5217 13.0446C16.5217 14.0051 17.3003 14.7837 18.2609 14.7837H21.7392C22.6997 14.7837 23.4783 14.0051 23.4783 13.0446C24.4388 13.0446 25.2174 12.266 25.2174 11.3054H25.1595C26.12 11.3054 26.9566 10.5268 26.9566 9.56629Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111350">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EcuadorSvg;
